import React, { useEffect, useState } from "react";

const QUOTE = "Empowering your business with IT solutions...";

export default function Loader({ onFinish, minDuration = 1500, isLoaded = false }) {
  const [fade, setFade] = useState(false);
  const [progress, setProgress] = useState(0);
  const [typed, setTyped] = useState("");
  useEffect(() => {
    let typingIdx = 0;
    let typingTimer;
    function typeChar() {
      setTyped(QUOTE.slice(0, typingIdx + 1));
      typingIdx++;
      if (typingIdx < QUOTE.length) {
        typingTimer = setTimeout(typeChar, 28);
      }
    }
    typeChar();
    return () => clearTimeout(typingTimer);
  }, []);

  // Progress bar animation
  useEffect(() => {
    let start = Date.now();
    let raf;
    function animate() {
      const elapsed = Date.now() - start;
      let pct = Math.min(100, (elapsed / minDuration) * 100);
      setProgress(pct);
      if (pct < 100 && !isLoaded) {
        raf = requestAnimationFrame(animate);
      } else if (isLoaded && pct >= 100) {
        setTimeout(() => setFade(true), 300);
        setTimeout(() => onFinish && onFinish(), 800);
      } else if (!isLoaded) {
        raf = requestAnimationFrame(animate);
      }
    }
    animate();
    return () => cancelAnimationFrame(raf);
  }, [minDuration, isLoaded, onFinish]);

  return (
    <div className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-br from-white to-indigo-100 transition-opacity duration-700 ${fade ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
      <svg width="120" height="120" viewBox="0 0 1280 1280" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          {/* Down curve - animated draw */}
          <path className="loader-path" d="M957.37,1052.76c-50.14,25.71-128.86,59.25-229.75,74.29-82.08,12.24-352.97,52.63-528.31-132.08-97.29-102.49-134.73-242.22-128.82-354.07,5.5-103.81,49.19-199.69,61.41-226.51,19.11-41.96,39.22-75.34,54.93-99.06-26.96,54.77-72.19,165.55-65.83,309.23,2.69,60.76,7.62,172.05,79.69,275.48,126.63,181.78,362.36,198.34,437.5,203.62,142.73,10.03,256.67-25.97,319.18-50.9Z" stroke="#1b1c4e" strokeWidth="16" fill="none"/>
          <path className="loader-path" d="M625.9,1032.29c-18.53,8.39-42.85,16.39-71.64,17.72-170.7,7.83-372.56-224.98-368.71-459.26,2.65-161.37,102.09-274.27,129.33-304.31,85.82-94.65,185.54-131.71,232.51-145.83-42.31,25.86-102.09,68.88-158.22,136.2-43.98,52.74-131.24,157.39-138.22,309.23-6.58,143.23,58.88,315.34,204.26,397.93,65.37,37.14,129.43,46.25,170.69,48.32Z" stroke="#1b1c4e" strokeWidth="16" fill="none"/>
          {/* Up curve - animated draw */}
          <path className="loader-path" d="M1091.87,266.1c9.62,5.69,17.81,11.86,34.11,24.3,9.85,7.52,21.57,16.47,33.17,29.96,2.57,2.99,13.02,15.38,23.85,37.15,19.19,38.59,20.48,68.26,23.83,67.87,2.99-.35,5.64-24.29-.14-48.76-7.45-31.56-23.7-52.91-30.57-61.45-9.76-12.13-19.53-20.73-26.6-26.29-5.62-5.03-10.71-8.86-14.68-11.62,0,0-13.97-9.74-27.25-14.74-.22-.08-.44-.16-.44-.16-.05-.02-.09-.03-.11-.04-11.94-4.35-25.12-5.75-25.8-3.66-.43,1.3,4.19,3.64,10.63,7.45Z" stroke="#1b1c4e" strokeWidth="10" fill="none"/>
          <path className="loader-path" d="M1045.88,295.61c16.52,6.56,27.18,15.2,38.22,24.15,14.3,11.59,24.97,23.65,32.71,33.94,6.11,7.47,14.41,19.02,21.4,34.55,15.04,33.4,13.98,64.48,12.54,78.88-1.05,10.52-3.7,26.11-11.01,44.03-.84,2.29-2.22,5.75-4.28,9.78-1.37,2.68-3.51,6.55-8.87,14.37-7.63,11.15-9.63,12.57-8.86,14.02,1.66,3.13,14.01,2.12,22.85-4.24,6.26-4.51,9.19-10.39,13.99-20.03,3.11-6.24,5-11.41,6.88-16.89,3.94-11.5,7.84-22.88,9.86-33.02,4.76-23.82.01-44.99-2.29-55.26-7.4-32.99-23.88-56.42-34.62-69.25-11.29-12.57-21.89-22.18-30.27-29.12,0,0-17.72-14.69-42.19-27.52-1.55-.81-8.11-4.19-17.31-5.99-7.13-1.4-16.58-1.3-16.86.26-.27,1.54,8.5,3.52,18.11,7.34Z" stroke="#1b1c4e" strokeWidth="10" fill="none"/>
          {/* T and A shapes - fade in */}
          <rect className="loader-fade" x="427.39" y="473.7" width="84.66" height="490.74" transform="translate(346.5 -130.94) rotate(24.91)" fill="#1b1c4e"/>
          <polygon className="loader-fade" points="1062.89 388.92 420.72 443.08 329.1 539.8 976.36 485.22 1063.31 393.44 1062.89 388.92" fill="#1b1c4e"/>
          <polyline className="loader-fade" points="1074.48 922.04 777.88 483.69 797.56 470.37 1097.18 913.19" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <line className="loader-fade" x1="1097.18" y1="913.19" x2="1099.12" y2="916.06" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <polyline className="loader-fade" points="1047.87 1014.08 776.06 612.34 758.97 623.9 1040.42 1039.86" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <polyline className="loader-fade" points="1040.42 1039.86 1056.48 1063.59 1056.48 1063.59" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <line className="loader-fade" x1="1097.28" y1="922.43" x2="1099.12" y2="916.06" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <line className="loader-fade" x1="1047.87" y1="1014.08" x2="1074.48" y2="922.04" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <line className="loader-fade" x1="1056.48" y1="1063.59" x2="1063.93" y2="1037.8" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <line className="loader-fade" x1="1097.28" y1="922.43" x2="1063.93" y2="1037.8" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <polygon className="loader-fade" points="1056.26 1062.38 1100.07 917.99 1081.13 890.26 1037.32 1034.65 1056.26 1062.38" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinejoin="round"/>
          <rect className="loader-fade" x="362.91" y="706.98" width="470.69" height="17.2" rx="8.6" ry="8.6" transform="translate(-302.72 956.85) rotate(-65.09)" fill="#1b1c4e"/>
          <polygon className="loader-fade" points="651.53 797.08 868.19 779.39 866.02 752.84 662.81 769.43 651.53 797.08" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinejoin="round"/>
          <polygon className="loader-fade" points="589.61 876.01 913.08 846.06 908.84 819.64 605.44 847.73 589.61 876.01" fill="none" stroke="#1b1c4e" strokeWidth="4" strokeLinejoin="round"/>
          {/* Circle accent - pulse */}
          <circle className="loader-pulse" cx="1145.08" cy="1019.91" r="41.87" fill="#fff" stroke="#1b1c4e" strokeWidth="4"/>
        </g>
        <style>{`
          .loader-path {
            stroke-dasharray: 2000;
            stroke-dashoffset: 2000;
            animation: loader-draw 1.1s cubic-bezier(.4,2,.6,1) forwards;
          }
          .loader-path:nth-of-type(2) { animation-delay: 0.15s; }
          .loader-path:nth-of-type(3) { animation-delay: 0.3s; }
          .loader-path:nth-of-type(4) { animation-delay: 0.45s; }
          @keyframes loader-draw {
            to { stroke-dashoffset: 0; }
          }
          .loader-fade {
            opacity: 0;
            animation: loader-fadein 0.7s ease forwards;
            animation-delay: 0.8s;
          }
          @keyframes loader-fadein {
            to { opacity: 1; }
          }
          .loader-pulse {
            opacity: 0;
            animation: loader-pulsein 0.7s cubic-bezier(.4,2,.6,1) forwards, loader-pulse 1.2s 1.5s infinite alternate;
            animation-delay: 1.1s, 1.5s;
          }
          @keyframes loader-pulsein {
            to { opacity: 1; }
          }
          @keyframes loader-pulse {
            0% { filter: drop-shadow(0 0 0px #a5b4fc); }
            100% { filter: drop-shadow(0 0 16px #a5b4fc); }
          }
        `}</style>
      </svg>
      {/* Progress bar */}
      <div className="w-48 h-2 mt-8 bg-indigo-100 rounded-full overflow-hidden shadow-inner">
        <div className="h-full bg-gradient-to-r from-indigo-400 to-indigo-600 transition-all duration-200" style={{ width: `${progress}%` }} />
      </div>
      {/* Typing quote */}
      <div className="mt-6 text-base md:text-lg font-mono text-[#23244d] dark:text-white/80 min-h-[2.5em]">
        {typed}
        <span className="animate-pulse">|</span>
      </div>
    </div>
  );
} 